export enum serviceTypeEnum {
    Treatment = 0,
    Product = 1,
    Option = 2
}